module.exports = __webpack_public_path__ + "img/tiktok-brands-solid.3bb95858.svg";